/*
 * @Author: your name
 * @Date: 2020-12-08 20:06:53
 * @LastEditTime: 2020-12-08 20:43:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/service/chat_api.js
 */
import axios from "axios";
import { Message } from "element-ui";
// eslint-disable-next-line no-undef

const service = axios.create({
  headers: {
    Authorization: localStorage.getItem("token")
  }
});

// request interceptor 请求拦截
service.interceptors.request.use(
  config => {
    /* 原接口 */
    config.headers["Authorization"] = localStorage.getItem("token");
    // config.baseURL = jzbbaseurl
    // config.baseURL = 'http://192.168.137.59:8000/pay/'
    // config.baseURL = "http://192.168.137.59:9006";
    // if (config.method === 'post') {
    //   config.data = JSON.stringify(config.data)
    // }
    return config;
  },
  error => {
    // Do something with request error
    console.log("请求错误", error); // for debug
    Promise.reject(error);
  }
);

// response interceptor 响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      if (res.code !== 40101) {
        Message({
          message: res.msg || res.message,
          type: "error"
        });
        return res;
      }
    }
    return res;
  },
  error => {
    Message({
      message: error.message || error.msg,
      type: "error"
    });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/service/chat_api.js